import axios from "axios";
import { getApiUrl } from "../../config";

const clientBase = () => getApiUrl() + "/plugins/cw-reports";
const adminBase = () => getApiUrl() + "/plugin-admin/cw-reports";
const internalBase = () => getApiUrl() + "/plugins-internal/cw-reports";
const scopeBase = (clientId) => (clientId ? `${internalBase()}/clients/${encodeURIComponent(clientId)}` : clientBase());

const get = (url, params) => axios.request({ method: "get", url, params, withCredentials: true, crossorigin: true });
const put = (url, data) => axios.request({ method: "put", url, data, withCredentials: true, crossorigin: true });

export const requestGetSites = () => get(clientBase() + "/sites");
export const requestGetSite = (siteId, clientId) => get(`${scopeBase(clientId)}/sites/${encodeURIComponent(siteId)}`);
export const requestGetSiteChanges = (siteId, page, perPage, clientId) => get(`${scopeBase(clientId)}/sites/${encodeURIComponent(siteId)}/changes`, { page, perPage });
export const requestGetSiteReports = (siteId, clientId) => get(`${scopeBase(clientId)}/sites/${encodeURIComponent(siteId)}/reports`);
export const requestGetExposures = () => get(clientBase() + "/exposures");
export const requestGetExposureSummary = () => get(clientBase() + "/exposures", { summary: 1 });
export const requestGetReportFile = (siteId, reportId, part, clientId) =>
    axios.request({
        method: "get",
        url: `${scopeBase(clientId)}/sites/${encodeURIComponent(siteId)}/reports/${encodeURIComponent(reportId)}/file`,
        params: { part },
        responseType: "blob",
        withCredentials: true,
        crossorigin: true,
    });
export const requestGetFleet = () => get(internalBase() + "/fleet");
export const requestGetFleetExposures = (clientId) => get(internalBase() + "/exposures", clientId ? { client: clientId } : undefined);

export const requestGetSettings = () => get(adminBase() + "/settings");
export const requestUpdateSettings = (settings) => put(adminBase() + "/settings", settings);
export const requestGetServiceAccounts = () => get(adminBase() + "/service-accounts");
export const requestTestConnection = () => get(adminBase() + "/connection");
export const requestGetSiteMapping = () => get(adminBase() + "/site-mapping");
export const requestGetMappingAccounts = (clientId) => get(adminBase() + "/mapping-accounts", { clientId });
export const requestUpdateSiteMapping = (entries) => put(adminBase() + "/site-mapping", { entries });
export const requestUpdateClientSettings = (entries) => put(adminBase() + "/client-settings", { entries });
